import { Flex } from "@chakra-ui/react";
import { useMemo, useState } from "react";
import {
  FunnelConfigTypes,
  FunnelContextArea,
} from "../../../components/funnel/types";
import { useReaderPaywall } from "../hooks/useReaderPaywall";
import { useFunnel } from "../../../components/funnel/hooks/useFunnel";

interface ReaderPaywallProps {
  showPaywall: boolean;
  setFunnelPending: (pending: boolean) => void;
}
export function ReaderPaywall({
  showPaywall,
  setFunnelPending,
}: ReaderPaywallProps) {
  const [funnelConfig, setFunnelConfig] = useState<FunnelConfigTypes>();
  useReaderPaywall({
    showPaywall,
    setFunnelConfig,
    openType: funnelConfig?.type,
    modalContext: FunnelContextArea.verticalReader,
    setFunnelPending,
  });

  const readerFunnelConfig = useMemo(() => {
    return {
      ...funnelConfig,
      setFunnelConfig,
    };
  }, [funnelConfig]);

  const readerFunnelConfigWithAutoFocus = useMemo(() => {
    return {
      ...readerFunnelConfig,
      options: {
        ...readerFunnelConfig?.options,
        autoFocus: false,
      },
    };
  }, [readerFunnelConfig]);

  const { funnelHeader, funnelBody, funnelFooter, isAuthFunnel } = useFunnel(
    readerFunnelConfigWithAutoFocus ?? {},
  );

  if (!funnelConfig?.type) {
    return null;
  }
  return (
    <Flex
      width="100%"
      justifyContent="center"
      background="#141517f2"
      borderTopRadius="24px"
      overflow="auto"
    >
      <Flex
        height="100%"
        py="24px"
        width="100vw"
        justifyContent="center"
        onClick={(e) => e.stopPropagation()}
        filter="drop-shadow(rgba(0, 0, 0, 0.04)"
      >
        <Flex
          maxWidth="100vw"
          px="24px"
          overflowY="auto"
          flexDirection="column"
          gap="24px"
          alignItems="center"
          width="520px"
        >
          {!isAuthFunnel && funnelHeader}
          {funnelBody}
          {funnelFooter}
        </Flex>
      </Flex>
    </Flex>
  );
}
